import { fabric } from "fabric"
import { Canvas, IEvent, Object } from "fabric/fabric-impl";

import GraphicObject, { GraphicsObjectOptions } from "../../modules/GraphicObject";
import { keyboard } from "../../../input/keyboard";
import { drawLine } from "../../graphics/drawConnection";
import { nodePalette } from "../../../theme";

export type NodeTargetingOptions = {
	onNodeAdd: (x: number, y: number) => void
} & GraphicsObjectOptions

export default class NodeTargeting extends GraphicObject<Object, Canvas> {

	private from = null as any;
	private to = null as any;
	private targetingLineEnabled = false
	private targetingLine = new fabric.Line([0, 0, 0, 0], {
		evented: false,
		selectable: false,
		stroke: nodePalette.selection,
		strokeWidth: 2,
		strokeDashArray: [5, 10],
		strokeLineCap: "round",
	})

	onNodeAdd

	constructor({ onNodeAdd = () => { }, ...rest }: NodeTargetingOptions) {
		super(rest)
		this.onNodeAdd = onNodeAdd
	}

	addGraphics(canvas: Canvas) {
		super.addGraphics(canvas);

		if (this.graphics) {
			const g = this.graphics
			canvas.add(g)
			this.removeCallback = () => canvas.remove(g)
		}

		const startTargeting = (e: IEvent) => {
			this.targetingLineEnabled = true
			updateTargeting(e)
			canvas.add(this.targetingLine)
		}

		const updateTargeting = (e: IEvent) => {
			if (e.absolutePointer) {
				let toLeft = e.absolutePointer.x
				let toTop = e.absolutePointer.y
				let strokeWidth = 2
				let linkTo = null


				if (e.target && e.target.type === 'linkedgroup') {
					linkTo = e.target
				}

				if (linkTo && (linkTo !== this.from)) {
					toLeft = (linkTo.left || 0)
					toTop = (linkTo.top || 0)
					strokeWidth = 4
				}

				this.targetingLine.set({
					strokeWidth,
					x1: this.from.left,
					y1: this.from.top,
					x2: toLeft,
					y2: toTop
				})
				canvas.renderAll()
			}
		}

		const stopTargeting = () => {
			if (this.targetingLineEnabled) {
				canvas.remove(this.targetingLine)
				this.targetingLineEnabled = false
			}
		}

		canvas.on('mouse:dblclick', e => {
			const target = e.target
			if (target) {
				if (target.type === 'linkedgroup') {
					canvas.setActiveObject(target)
					canvas.requestRenderAll()
				}
			}
		})

		canvas.on('mouse:down', e => {
			const target = e.target
			if (target && keyboard.altDown) {
				this.from = null;
				this.to = null;

				if (target.type === 'linkedgroup') {
					this.from = target

					startTargeting(e)
					canvas.sendToBack(this.targetingLine)
				}
			}
		})

		canvas.on('mouse:up', e => {
			const target = e.target
			stopTargeting()
			if (target && keyboard.altDown && (target !== this.from) && this.from) {
				if (target.type === 'linkedgroup') {
					this.to = target

					const linkedObjectFrom = this.from.linkedObject
					const linkedObjectTo = this.to.linkedObject

					if (!linkedObjectFrom.connections.includes(linkedObjectTo)) {

						linkedObjectFrom.connections.push(linkedObjectTo)

						drawLine(canvas, this.from, this.to)
					}

					this.from = null;
					this.to = null;
				}
			}
		})

		canvas.on('mouse:move', e => {
			if (this.from && this.targetingLineEnabled) {
				if (!keyboard.altDown) {
					stopTargeting()
					return;
				}

				updateTargeting(e)
			}
		})

		canvas.on('mouse:up', e => {

			if (!e.target && e.isClick && e.absolutePointer && keyboard.shiftDown) {
				this.onNodeAdd(e.absolutePointer.x, e.absolutePointer.y,)
			}
		})
	}
}